import { RouteType } from "routes/types";
import { lazy } from "react";

const Element = lazy(() => import("./index"));

const route: RouteType = {
  id: 1100,
  parentId: 1000,
  name: "InfoHome",
  label: "Home",
  path: "/",
  icon: "home",
  element: Element,
  footer: true,
  admin: false,
};

export default route;
